module.exports = "//public.getcloudapp.com/packs/media/images/pattern-54fe489ce04f00fcf6cfe8eef05a8daf.png";